import { render } from "./TeacherInformation.vue?vue&type=template&id=5f8053ca&scoped=true&ts=true"
import script from "./TeacherInformation.vue?vue&type=script&lang=ts"
export * from "./TeacherInformation.vue?vue&type=script&lang=ts"

import "./TeacherInformation.vue?vue&type=style&index=0&id=5f8053ca&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8053ca"]])

export default __exports__